
import { Component, Vue } from "vue-property-decorator";
import vuexStore, { EnumEditStatus } from "@/store/vuex-store";
import Auth from "@/lib/common/auth";
import {
  ExamComponent,
  ExamUpdateName
} from "@/lib/model/exambuilder/exam-component/exam";
import {
  CandidateCount,
  CandidateCountSearch
} from "@/lib/model/exambuilder/exam-component/statistics";
import {
  EnumSubmitStatus,
  CandidateItem,
  CandidateList,
  CandidateSearch,
  CandidateCreateOne,
  CandidateCreateMore
} from "@/lib/model/exambuilder/exam-component/candidate";
import Loading from "@/components/loading.vue";
import DelExam from "../components/del-exam.vue";
import SelectTemplate from "../components/select-template.vue";
import AsyncDownloadModal from "../components/async-download-modal.vue";
import ExamInfo from "../components/exam-info.vue";
import ExamLink from "../components/exam-link.vue";
import RingGraph from "../components/ring-graph.vue";
import TableChars from "../components/table-chars.vue";
import CandidateTable from "../components/candidate-table.vue";
import AddMoreCandidateModal from "../components/add-candidates.vue";
import AddOneCandidateModal from "../components/add-candidate.vue";
import EllipShow from "@/components/ellipShow.vue";
import {
  ExamAllList,
  ExamAllSearch,
  ExamItem,
  ExamList
} from "@/lib/model/exambuilder/exam-component/exam-list";

@Component({
  components: {
    CandidateTable,
    DelExam,
    SelectTemplate,
    AsyncDownloadModal,
    ExamInfo,
    ExamLink,
    RingGraph,
    TableChars,
    Loading,
    AddMoreCandidateModal,
    AddOneCandidateModal,
    EllipShow
  }
})
export default class ExamCandidateList extends Vue {
  async created() {
    if (this.$route.query.examId) {
      this.examId = Number(this.$route.query.examId);
      this.searchForm.examId = this.examId;
    }
    await this.getExam();
    await this.getCandidateList();
    this.getAllExam();
  }

  back() {
    this.$router.push({ path: "/exam-component/paper" });
  }

  // 面试基本信息
  pageShow = false;
  examId = 0;
  exam: ExamComponent = new ExamComponent();
  examAllList = new ExamAllList();

  get totalTime() {
    const m = Math.floor(this.exam.examVersionInfo.useTimeSecond / 60);
    const s = this.exam.examVersionInfo.useTimeSecond % 60;
    return m + Number(Boolean(s));
  }

  async getExam() {
    try {
      this.exam = await ExamComponent.get(this.examId);
      this.pageShow = true;
      await this.candidateCount();
    } catch (error) {
      console.log("error:", error);
      this.pageShow = true;
    }
  }

  getAllExam() {
    const params = new ExamAllSearch().assign({ returnAll: true });
    ExamAllList.getList(params).then(res => {
      this.examAllList = new ExamAllList().assign(res);
    });
  }

  // 统计
  candidateCountInfo = new CandidateCount();
  echartsList = [
    {
      proportion: 0,
      tip: "到面率=参面人数/邀请人数",
      name: "到面率"
    },
    {
      proportion: 0,
      tip: "完面率=完面人数/参面人数",
      name: "完面率"
    }
  ];
  recommendList: number[] = [];

  async candidateCount() {
    try {
      const params = new CandidateCountSearch().assign({ examId: this.examId });
      this.candidateCountInfo = await CandidateCount.get(params);
      const {
        all,
        inviteNumber,
        joinNumber,
        finishNumber,
        finish
      } = this.candidateCountInfo;

      if (inviteNumber !== 0) {
        this.echartsList[0].proportion = (joinNumber * 100) / inviteNumber;
      }

      if (joinNumber !== 0) {
        this.echartsList[1].proportion = (finishNumber * 100) / joinNumber;
      }

      this.recommendList = [
        finish.aiRecommendStatusVeryRecommend,
        finish.aiRecommendStatusRecommend,
        finish.aiRecommendStatusNormal,
        finish.aiRecommendStatusNotRecommend
      ];
      this.$nextTick(() => {
        const ref = this.$refs.tableCharsRef as any;

        try {
          ref.option.series[0].left = "-160px";
          ref.option.series[0].radius = "100%";
          ref.option.series[0].top = "16px";
          ref.option.legend.top = "28px";
          delete ref.option.series[0].width;
        } catch (error) {
          //
        }

        ref.updateOption();
      });
    } catch (error) {
      console.log("统计", error);
    }
  }

  // 候选人列表
  get EnumSubmitStatus() {
    return EnumSubmitStatus;
  }

  paramList: string[] = [];
  loadingList = true;
  submitStatus: string | EnumSubmitStatus = "";
  searchForm = new CandidateSearch().assign({
    companyId: Number(Auth.companyId)
  });
  data: CandidateItem[] = [];
  total = 0;

  handleChangeSubmitStatus(val: "" | EnumSubmitStatus) {
    this.searchForm.page = 1;

    if (val === "") {
      this.searchForm.submitStatusList = [];
      return this.getCandidateList();
    }

    if (val === EnumSubmitStatus.EnumSubmitStatusFinish) {
      this.searchForm.submitStatusList = [
        EnumSubmitStatus.EnumSubmitStatusFinish,
        EnumSubmitStatus.EnumSubmitStatusNoScore
      ];
      return this.getCandidateList();
    }

    this.searchForm.submitStatusList = [val];
    this.getCandidateList();
  }

  handleQuickSearch({ type, row }: { type: string; row: CandidateItem }) {
    this.searchForm.page = 1;

    if (type === "repeatExam") {
      this.searchForm.submitStatusList = [];
      this.searchForm.searchKey = row.phone;
      this.getCandidateList();
    }
  }

  handleRefresh() {
    this.candidateCount();
    this.getCandidateList();
  }

  async getCandidateList() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.loadingList = true;
    const res = await CandidateList.getList(this.searchForm);
    this.data = res.list;
    this.total = res.count;
    this.paramList = res.list[0]?.paramList.map(item => item.name) || [];
    this.loadingList = false;
  }

  // 检查所依赖视频是否全部生成完成
  async checkVideoFinish() {
    const res = await ExamList.checkVideoFinish({
      examId: this.exam.metaInfo.examId,
      examVersionId: this.exam.metaInfo.examVersionId
    });
    if (res.code === 0 && !res.data?.finishAll) {
      this.$message.error(
        `面试【${this.exam.examInfo.name}】(ID:${this.exam.metaInfo.examId},面试批次:${this.exam.metaInfo.examVersionId})下的数字人视频正在生成中，请耐心等待！`
      );
      return false;
    }
    return true;
  }

  // 操作
  async showDialog(scenes: string) {
    if (scenes === "link") {
      const isFinish = await this.checkVideoFinish();
      if (!isFinish) return;
      this.showExamLink = true;
      return;
    }

    if (scenes === "examInfo") {
      this.examInfoMode = "edit";
      this.editExamInfoParam = new ExamUpdateName().assign({
        examId: this.exam.metaInfo.examId,
        name: this.exam.examInfo.name,
        remark: this.exam.examInfo.remark,
        positionId: this.exam.examInfo.positionId
      });
      this.showExamInfo = true;
      return;
    }

    if (scenes === "copyExam") {
      this.examInfoMode = "copy";
      this.showExamInfo = true;
      this.editExamInfoParam = new ExamUpdateName().assign({
        examId: this.exam.metaInfo.examId,
        name: this.exam.examInfo.name,
        remark: this.exam.examInfo.remark,
        positionId: this.exam.examInfo.positionId
      });
      return;
    }

    if (scenes === "removeExam") {
      this.showDelExam = true;
      this.delParam = {
        name: this.exam.examInfo.name,
        examId: this.examId
      };
      return;
    }

    if (scenes === "messageTemplate") {
      this.showSelectTemplate = true;
      return;
    }

    if (scenes === "exportCandidate") {
      this.exportCandidate();
      return;
    }

    if (scenes === "examQuestion") {
      this.$router.push({
        name: "ai-builder-component",
        query: { paperId: this.examId as any, cid: Auth.companyId, step: "1" }
      });
      return;
    }

    if (scenes === "examConfig") {
      this.$router.push({
        name: "ai-builder-component",
        query: { paperId: this.examId as any, cid: Auth.companyId, step: "3" }
      });

      return;
    }

    if (scenes === "addCandidate") {
      return this.showAddCandidate("one");
    }

    if (scenes === "addCandidates") {
      return this.showAddCandidate("more");
    }
  }

  changeEditStatus(status: EnumEditStatus) {
    vuexStore.setEditStatus(status);
  }

  // 编辑面试
  submitting = false;
  examInfoMode = "edit";
  showExamInfo = false;
  editExamInfoParam = new ExamUpdateName();

  async examInfoEditOk(data: ExamUpdateName) {
    if (this.submitting) return;

    this.submitting = true;

    if (this.examInfoMode === "edit") {
      const res = await ExamComponent.updateName(data);

      if (res.code !== 0) return;

      await this.getExam();

      this.changeEditStatus(EnumEditStatus.EnumInsert);
      this.$message.success("编辑成功");
      this.submitting = false;
    } else {
      const res = await ExamComponent.copy(data);

      if (res.code !== 0) return;

      this.$message.success("复制成功");
      this.changeEditStatus(EnumEditStatus.EnumInsert);
      this.back();
    }

    this.showExamInfo = false;
  }

  // 邀请候选人弹窗
  showExamLink = false;

  // 删除面试
  showDelExam = false;
  delParam = {
    examId: 0,
    name: ""
  };

  async delSuccess() {
    const res = await ExamComponent.delete(this.examId);

    if (res.code !== 0) return;

    this.showDelExam = false;
    this.$message.success("删除成功");
    this.changeEditStatus(EnumEditStatus.EnumInsert);
    this.back();
  }

  // 消息模板
  showSelectTemplate = false;

  setTemplateOK() {
    this.$message.success("保存成功");
    this.showSelectTemplate = false;
  }

  // 导出候选人
  exportCandidate() {
    CandidateList.export(this.searchForm).then(res => {
      if (res.code === 0) {
        this.isShowDownloadModal = true;
      }
    });
  }

  // 邀请候选人
  isShowAddMore = false;
  isShowAddOne = false;

  showAddCandidate(key: string) {
    if (key === "one") {
      this.candidateCreateOne.examId = this.examId;
      this.isShowAddMore = false;
      this.isShowAddOne = true;
      this.changeEditStatus(EnumEditStatus.EnumInsert);
    } else if (key === "more") {
      this.candidateCreateMore.examId = this.examId;
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }

  // 添加一个候选人
  candidateCreateOne = new CandidateCreateOne();

  closeAddOneCandidate() {
    this.isShowAddOne = false;
  }

  // 添加多名候选人
  candidateCreateMore = new CandidateCreateMore();

  closeAddMoreCandidate() {
    this.isShowAddMore = false;
  }

  confirm() {
    this.changeEditStatus(EnumEditStatus.EnumInsert);
  }

  async successAddMore() {
    this.getCandidateList();
  }

  // 导出候选人
  isShowDownloadModal = false;

  // 删除候选人
  candidateDel() {
    this.changeEditStatus(EnumEditStatus.EnumInsert);
  }
}
